import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/chat/ArtifactCard.tsx
// Compact card shown inside an AgentMessage when a substantive document was produced.
// Links to the full artifact in /artifacts.
import { Link } from "react-router-dom";
const ARTIFACT_ICONS = {
    retirement_projection: "◎",
    portfolio_plan: "◆",
    tax_strategy: "◈",
    xray_report: "◉",
    goal_analysis: "◇",
    pinned_message: "📌",
    custom: "❋",
};
const ARTIFACT_LABELS = {
    retirement_projection: "Retirement Projection",
    portfolio_plan: "Portfolio Plan",
    tax_strategy: "Tax Strategy",
    xray_report: "X-Ray Report",
    goal_analysis: "Goal Analysis",
    pinned_message: "Pinned Response",
    custom: "Document",
};
export function ArtifactCard({ artifactId, type, title, agentChain = [], confidence, className = "", }) {
    const icon = ARTIFACT_ICONS[type] ?? "❋";
    const label = ARTIFACT_LABELS[type] ?? "Document";
    return (_jsxs(Link, { to: `/artifacts`, state: { highlight: artifactId }, className: `flex items-start gap-3 p-3 bg-slate-800/60 border border-slate-700/60 hover:border-slate-600/60 rounded-xl transition-colors group ${className}`, children: [_jsx("span", { className: "text-slate-500 text-base mt-0.5 shrink-0", children: icon }), _jsxs("div", { className: "flex-1 min-w-0 space-y-0.5", children: [_jsx("div", { className: "text-xs text-slate-500", children: label }), _jsx("div", { className: "text-sm text-slate-300 font-medium truncate group-hover:text-slate-200 transition-colors", children: title }), agentChain.length > 0 && (_jsx("div", { className: "text-[10px] text-slate-600", children: agentChain.join(" → ") }))] }), _jsxs("div", { className: "flex flex-col items-end gap-1 shrink-0", children: [confidence !== undefined && (_jsxs("span", { className: `text-[10px] font-medium ${confidence >= 0.8 ? "text-emerald-400" :
                            confidence >= 0.5 ? "text-amber-400" :
                                "text-rose-400"}`, children: [Math.round(confidence * 100), "%"] })), _jsxs("svg", { className: "text-slate-600 group-hover:text-slate-400 transition-colors", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }), _jsx("polyline", { points: "15 3 21 3 21 9" }), _jsx("line", { x1: "10", y1: "14", x2: "21", y2: "3" })] })] })] }));
}
